import React from 'react'
import { BaseUrl } from '../../Helper/BaseUrl'

export default function HeaderLogo() {
    return (
        <>
            <a href="" className="b-brand">
                {/* <!-- ========   change your logo hear   ============ --> */}
                {
                    BaseUrl === "http://pcmcapi.cdatinfotech.com" ?

                        <img src="../assets/img/PCMC_Logo-01.png" alt="" className="logo " style={{ width: '70px' }} />
                        :
                        <img src="../assets/img/nmmc_large_logo2.png" alt="" className=" "  style={{ width: '60px' }}/>
                }
            </a>
        </>
    )
}
